export default __webpack_public_path__ + "assets/background-new.16aef641a51b8c4d2637b436786745a8.svg";